import '@angular/localize/init';
export * from './lib/feature-tax-client-list.module';

export * from './lib/tax-client-list/feature-tax-client-list.component';
